import { applyStylesToMobileExperience } from '../BaseAnimatedExperienceController/BaseAnimatedExperienceController.styles';
import styled, { css } from 'styled-components';

export const PeopleExplorerBackgroundContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  ${applyStylesToMobileExperience(css`
    height: 550px;
  `)}
`;

export const Profile = styled.div<{ delay?: number; fixed?: boolean }>`
  position: absolute;
  border-radius: 50%;
  overflow: hidden;
  animation: ${({ fixed }) => (fixed ? 'none' : 'smoothBounceBall 2.5s')};
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-delay: ${({ delay }) => `${delay || 0}s`};

  @keyframes smoothBounceBall {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      transform: translate3d(0, 10px, 0);
    }
  }
`;
